module.exports = __webpack_public_path__ + "static/media/4_1.889fa425.jpg";